(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["stact-professional-pages"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function(event) {
  var link = event.target.closest('.stact-editorial-hero a[href="#samarbejde"]');
  if (!link) return;
  var target = document.getElementById('samarbejde');
  if (!target) return;
  event.preventDefault();
  event.stopImmediatePropagation();
  target.scrollIntoView({behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start'});
}, true);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["stact-support-pages"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-support-page]').forEach(root=>{
root.addEventListener('click',event=>{const link=event.target.closest('a[href="#stact-manuals"]');if(!link)return;event.preventDefault();event.stopImmediatePropagation();root.querySelector('#stact-manuals').scrollIntoView({block:'start'});},true);
root.querySelectorAll('[data-embed]').forEach(link=>link.addEventListener('click',event=>{event.preventDefault();const frame=document.createElement('iframe');frame.src=link.dataset.embed;frame.title=link.closest('article').querySelector('h3').textContent;frame.allow='autoplay; encrypted-media; picture-in-picture; fullscreen';frame.allowFullscreen=true;frame.tabIndex=0;link.parentElement.replaceChildren(frame);frame.focus();}));
const grid=root.querySelector('.sv-grid');if(!grid)return;const cards=[...grid.querySelectorAll('.sv-card')],more=root.querySelector('.sv-more'),counter=root.querySelector('[data-counter]');let filter='all',limit=6;
const update=()=>{const matching=cards.filter(card=>filter==='all'||card.dataset.category===filter);cards.forEach(card=>card.hidden=true);matching.slice(0,limit).forEach(card=>card.hidden=false);more.hidden=limit>=matching.length;counter.hidden=false;counter.textContent=counter.dataset.pattern.replace('[shown]',Math.min(limit,matching.length)).replace('[total]',matching.length);};
root.querySelector('.sv-filters').hidden=false;root.querySelectorAll('[data-filter]').forEach(button=>button.addEventListener('click',()=>{filter=button.dataset.filter;limit=6;root.querySelectorAll('[data-filter]').forEach(other=>other.setAttribute('aria-pressed',String(button===other)));grid.querySelectorAll('iframe').forEach(frame=>{frame.src=frame.src;});update();}));more.addEventListener('click',()=>{limit+=6;update();});update();
});
  } catch(e) { console.error(e); }
})();

})();
